import { axiomTokens, MaterialUICore, Box } from '@iclinic/design-system';

const { styled } = MaterialUICore;

const { spacing } = axiomTokens;

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const Content = styled('div')({
  flex: 1,
  padding: ` 0 ${spacing['8']}`,
});

export const ContentText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  letterSpacing: 0.44,
  gap: spacing['2'],
});

export const LoaderWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 150,
});
